'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fr_BE = require('../../date-picker/locale/fr_BE');

var _fr_BE2 = _interopRequireDefault(_fr_BE);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _fr_BE2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/locale/fr_BE.tsx
 ** module id = 750
 ** module chunks = 1
 **/